export default __webpack_public_path__ + "static/media/kitchen3-before1-1440w.58a96d19.png";